import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2022发现重庆之美调查推选活动';
const url = window.location.pathname;
const baseUrl = url.includes('public')
  ? '20230202CQZM/public'
  : url.includes('weChat')
  ? '20230202CQZM/weChat'
  : '20230202CQZM';

const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/news`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'citizen',
      name: `${baseUrl}-citizen`,
      component: () => import('./pages/Citizen.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'introduce',
      name: `${baseUrl}-introduce`,
      component: () => import('./pages/Introduce.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
